<template>
<v-container class="mb-0 px-2">
  <h2 class="texts">{{title}} ({{percent}}%)</h2>
    <v-data-table
      :id="tableName"
      dense
      disable-sort
      hide-default-footer
      :headers="showHeaders"
      :items="[valores]"
      class="lotesListTable"
    >
      <template v-slot:item.valorInformado="{ item }">
        <b>{{ item.valorInformado | formatPrice}}</b>
      </template>
      <template v-slot:item.valorLiberado="{ item }">
        <b style="color:#32B88B">{{ item.valorLiberado | formatPrice }}</b>
      </template>
      <template v-slot:item.valorGlosado="{ item }">
        <span style="color:#D0021B">{{ item.valorGlosado | formatPrice }}</span>
      </template>
      <template v-slot:item.valorRecursado="{ item }">
        <span style="color:#32B88B">{{ item.valorRecursado | formatPrice }}</span>
      </template>
      <template v-slot:item.valorAcatado="{ item }">
        <span style="color:red">{{ item.valorAcatado | formatPrice }}</span>
      </template>
    </v-data-table>
</v-container>
</template>

<script>
import moment from 'moment'
export default {
  data() {
    return {
      showTable: true,
      headers: [
        { text: "Vl.informado", value: "valorInformado", align: "right", sortable: false, show: true },
        { text: "Vl.liberado", value: "valorLiberado", align: "right", sortable: false, show: true },
        { text: "Glosa Inicial", value: "valorGlosado", align: "right", sortable: false, show: true },
        { text: "Glosa recursada", value: "valorRecursado", align: "right", sortable: false, show: this.pagamentoPublicado },
        { text: "Glosa acatada", value: "valorAcatado", align: "right", sortable: false, show: this.pagamentoPublicado},
      ]
    }
  },
  props:{
    valores: Object,
    tableName: String,
    title: String,
    pagamentoPublicado: Boolean
  },
  filters:{
      formatData(val){
      return  moment(val).format('DD/MM/YYYY')
      },
      formatPrice(value) {
          let val = (value/1).toFixed(2).replace('.', ',')
          return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      }
  },
  computed: {
    percent () {
      return (this.valores.percent * 100).toFixed(1)
    },
    showHeaders () {
      return this.headers.filter(header => header.show)
    }
  }
}
</script>

<style>
tr:first-child.destaque {
  border-bottom: solid 2px #d1dcea;
  background-color: #d1dcea;
}
</style>
